module.exports = __webpack_public_path__ + "img/Pic_LOGO_XYZQ_NEWS.d1b688fe.png";